<template>
  <div class="dataContent">
    <div class="dataTitle">数据统计说明<span class="dataTitleTips"></span></div>
    <div style="padding: 20px 20px 0;">
      1、<span class="bold">单阶段数据</span>：如教槽、保育前期等，指实证中仅填写单一阶段的数据。若填写阶段超出1个，则不属于单阶段数据。<br />
      2、<span class="bold">全程数据</span>：指实证体重区间≥100kg，或填写全部7个实证阶段的数据<br />
      3、<span class="bold">其他</span>：指即不属于单阶段，又不属于全程的数据。<span class="red">该类数据正常纳入统计，暂不纳入分析</span><br />
      4、<span class="bold">异常数据</span>：指料肉比异常（{{lessThan}}0.5或{{greaterThan}}10 ）或造肉成本异常（{{lessThan}}1 或{{greaterThan}}20）的数据。<span class="red">该类数据正常纳入统计，暂不纳入分析</span>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: [],
  data() {
    return {
      greaterThan: '>',
      lessThan: '<',
    }
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>
<style lang='scss'></style>
<style lang='scss' scoped></style>